module.exports = __webpack_public_path__ + "cf461cb1cda349f8a29f4303e65b3b67.pdf";